<template>
  <article class="transaction-chart card">
    <ChartHeader
      v-model="selected"
      :price="coin.formated"
      :intervals="intervals"
      />

    <ApexChart class="transaction-chart__chart" width="100%" height="435" type="candlestick" :options="options" :series="series" />
  </article>
</template>

<script>
  import ApexChart from 'vue-apexcharts';
  import { format, createChartArray } from '@/helpers';
  import { mapState, mapGetters, mapMutations } from 'vuex';
  import ChartHeader from '@/components/Transaction/Chart/Header';

  export default {
    components: {
      ApexChart,
      ChartHeader,
    },

    data: () => ({
      selected: '24H',
    }),

    computed: {
      ...mapState('coins', [
        'coins',
      ]),

      ...mapGetters('coins', [
        'coin',
      ]),

      prices () {
        return this.series[0].data.map(([, value]) => value);
      },

      interval () {
        return this.intervals[this.selected];
      },

      intervals () {
        return {
          '1H': [
            60, 60 * 1000, 100000,
          ],

          '24H': [
            48, 30 * 60 * 1000, 10000,
          ],

          '1S': [
            56, 3 * 60 * 60 * 1000, 1000,
          ],

          '1A': [
            24, 12 * 30 * 60 * 60 * 1000, 500,
          ],

          'MAX': [
            48, 12 * 30 * 60 * 60 * 1000, 100,
          ],
        };
      },

      series () {
        window.a = [{
          data: [
            {
              x: new Date(1538836200000),
              y: [6575.96, 6589, 6571.77, 6588.92]
            },
            {
              x: new Date(1538838000000),
              y: [6588.92, 6594, 6577.55, 6589.22]
            },
            {
              x: new Date(1538839800000),
              y: [6589.3, 6598.89, 6589.1, 6596.08]
            },
            {
              x: new Date(1538841600000),
              y: [6597.5, 6600, 6588.39, 6596.25]
            },
            {
              x: new Date(1538843400000),
              y: [6598.03, 6600, 6588.73, 6595.97]
            },
            {
              x: new Date(1538845200000),
              y: [6595.97, 6602.01, 6588.17, 6602]
            },
            {
              x: new Date(1538847000000),
              y: [6602, 6607, 6596.51, 6599.95]
            },
            {
              x: new Date(1538848800000),
              y: [6600.63, 6601.21, 6590.39, 6591.02]
            },
            {
              x: new Date(1538850600000),
              y: [6591.02, 6603.08, 6591, 6591]
            },
            {
              x: new Date(1538852400000),
              y: [6591, 6601.32, 6585, 6592]
            },
            {
              x: new Date(1538854200000),
              y: [6593.13, 6596.01, 6590, 6593.34]
            },
            {
              x: new Date(1538856000000),
              y: [6593.34, 6604.76, 6582.63, 6593.86]
            },
            {
              x: new Date(1538857800000),
              y: [6593.86, 6604.28, 6586.57, 6600.01]
            },
            {
              x: new Date(1538859600000),
              y: [6601.81, 6603.21, 6592.78, 6596.25]
            },
            {
              x: new Date(1538861400000),
              y: [6596.25, 6604.2, 6590, 6602.99]
            },
            {
              x: new Date(1538863200000),
              y: [6602.99, 6606, 6584.99, 6587.81]
            },
            {
              x: new Date(1538865000000),
              y: [6587.81, 6595, 6583.27, 6591.96]
            },
            {
              x: new Date(1538866800000),
              y: [6591.97, 6596.07, 6585, 6588.39]
            },
            {
              x: new Date(1538868600000),
              y: [6587.6, 6598.21, 6587.6, 6594.27]
            },
            {
              x: new Date(1538870400000),
              y: [6596.44, 6601, 6590, 6596.55]
            },
            {
              x: new Date(1538872200000),
              y: [6598.91, 6605, 6596.61, 6600.02]
            },
            {
              x: new Date(1538874000000),
              y: [6600.55, 6605, 6589.14, 6593.01]
            },
            {
              x: new Date(1538875800000),
              y: [6593.15, 6605, 6592, 6603.06]
            },
            {
              x: new Date(1538877600000),
              y: [6603.07, 6604.5, 6599.09, 6603.89]
            },
            {
              x: new Date(1538879400000),
              y: [6604.44, 6604.44, 6600, 6603.5]
            },
            {
              x: new Date(1538881200000),
              y: [6603.5, 6603.99, 6597.5, 6603.86]
            },
            {
              x: new Date(1538883000000),
              y: [6603.85, 6605, 6600, 6604.07]
            },
            {
              x: new Date(1538884100000),
              y: [6604.98, 6606, 6604.07, 6606]
            },
          ]
        }];

        return window.a;
      },

      options () {
        return {
          chart: {
            toolbar: {
              show: false,
            },

            zoom: {
              enabled: false,
            },

            animations: {
              enabled: false,
            },
          },

          grid: {
            borderColor: 'rgba(255, 255, 255, 0.08)',
            padding: {
              top: 0,
              right: 5,
              left: 15,
              bottom: 26,
            },
          },

          yaxis: {
            decimalsInFloat: 0,
            forceNiceScale: true,

            tooltip: {
              enabled: true
            },

            labels: {
              style: {
                cssClass: 'transaction-chart__label',
              },
            },
          },

          plotOptions: {
            candlestick: {
              colors: {
                upward: '#60c100',
                downward: '#ff001f'
              }
            }
          },

          xaxis: {
            type: 'datetime',

            labels: {
              offsetY: 5,

              style: {
                cssClass: 'transaction-chart__label transaction-chart__label--x',
              },

              datetimeFormatter: {
                year: 'MM / yyyy',
                month: "MM / yyyy",
                day: 'dd / MM',
                hour: 'HH:mm',
              },
            },

            axisBorder: {
              color: 'rgba(255, 255, 255, 0.08)',
            },

            axisTicks: {
              height: 8,
              offsetY: 8,
              color: 'rgba(255, 255, 255, 0.3)',
            },

            tooltip: {
              enabled: false,
            },
          },
        };
      },
    },
  };
</script>

<style lang="scss">
  .transaction-chart {
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    &__label {
      fill: #b2b8c5;
      font-size: 13px;
      font-family: Rubik;
      letter-spacing: 0.26px;
    }

    &__chart {
      padding: 0 24px 0 12px;
    }
  }
</style>
